import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=27880ba4&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"
import style0 from "./Business.vue?vue&type=style&index=0&id=27880ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27880ba4",
  null
  
)

export default component.exports